import {
  reSocialGroupTypesConstants 
} from './constants'
import api from './api';
import { defAction } from '../../../helpers/defaultAction';

export const socialGroupActions = {
  getSocialGroupTypes,
  getSocialGroupByName,
  createSocialGroupType,
  deleteSocialGroupType,
  updateSocialGroupType,
  restoreSocialGroupType,
  clearSocialGroupType
}

function getSocialGroupTypes(params) {
  return dispatch => {
    dispatch(request())
    
    api.getSocialGroupTypes(params).then(res => {
      dispatch(success(res))
    }).catch(e => {
      dispatch(failure(e))
    })

    function request() { return {
      type: reSocialGroupTypesConstants.SEND_RESOCIALGROUPTYPES_REQUEST
    } }
    function success(socialGroupTypes) { return {
      type: reSocialGroupTypesConstants.SEND_RESOCIALGROUPTYPES_SUCCESS,
      payload: socialGroupTypes
    } }
    function failure(error) { return {
      type: reSocialGroupTypesConstants.SEND_RESOCIALGROUPTYPES_FAILURE,
      payload: error
    } }
  }
}

function getSocialGroupByName(params) {
  return dispatch => {
    dispatch(request())
    
    api.getSocialGroupByName(params).then(res => {
      dispatch(success(res))
    }).catch(e => {
      dispatch(failure(e))
    })

    function request() { return {
      type: reSocialGroupTypesConstants.SEND_RESOCIALGROUPTYPES_REQUEST
    } }
    function success(socialGroupTypes) { return {
      type: reSocialGroupTypesConstants.SEND_RESOCIALGROUPTYPES_SUCCESS,
      payload: socialGroupTypes
    } }
    function failure(error) { return {
      type: reSocialGroupTypesConstants.SEND_RESOCIALGROUPTYPES_FAILURE,
      payload: error
    } }
  }
}
function createSocialGroupType(params) {
  const dispatchObj = {
    constants: reSocialGroupTypesConstants.createSocialGroupType,
    service: {
      func: api.createSocialGroupType,
      params: params,
    },
  }

  return defAction(dispatchObj)
}

function deleteSocialGroupType(params) {
  const dispatchObj = {
    constants: reSocialGroupTypesConstants.deleteSocialGroupType,
    service: {
      func: api.deleteSocialGroupType,
      params: params,
    },
  }

  return defAction(dispatchObj)
}

function updateSocialGroupType(params) {
  const dispatchObj = {
    constants: reSocialGroupTypesConstants.updateSocialGroupType,
    service: {
      func: api.updateSocialGroupType,
      params: params,
    },
  }

  return defAction(dispatchObj)
}

function restoreSocialGroupType(params) {
  const dispatchObj = {
    constants: reSocialGroupTypesConstants.restoreSocialGroupType,
    service: {
      func: api.restoreSocialGroupType,
      params: params,
    },
  }

  return defAction(dispatchObj)
}

function clearSocialGroupType() {
  return (dispatch) =>
  dispatch({
    type: reSocialGroupTypesConstants.SEND_RESOCIALGROUPTYPES_CLEAR,
  })
}